import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import Table from "react-bootstrap/Table";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Link } from "react-router-dom";
import {
  BodyAsFormData,
  encodedUrlBuliding,
} from "../../../services/utilities/util";
import jsPDF from "jspdf";
import "jspdf-autotable";
import md5 from "md5";
import { downloadPdf } from "../../../services/utilities/util";
import { connect } from "react-redux";
import { JsonToExcel } from "react-json-to-excel";
import { convertJsonForExcel } from "../../../services/utilities/util";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class KeyProjects extends React.Component {
  static contextType = FilterContext;

  state = {
    gradeText: "Switch To All Grade",
    grade: "AA+",
    keyProjects: [],
    filters: "",
    showLoader: false,
    showGraph: false,
    tHead: [],
    complexNames: [],
    jsonForExcel: [],
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    // this.state.filters = filters;
    this.setState({ filters: filters });
    apiMiddleware
      .post("api/edge/office/get_key_projects", BodyAsFormData(filters))
      .then((res) => {
        let splicedData = res.data;
        this.setState({ showLoader: false, showGraph: true });
        this.setState({
          keyProjects: splicedData,
          jsonForExcel: convertJsonForExcel(splicedData, {
            asset: { name: "Asset", type: "string" },
            micromarket: { name: "Micro-Market", type: "string" },
            asset_efficiency: { name: "Efficiency", type: "int" },
            leaseable_area: { name: "Leasable Area (msf)", type: "int" },
            occupancy_percent: { name: "Occupancy (%)", type: "int" },
            carpet_area_effective_rent: {
              name: "On Carpet Area (Effective Rent)",
              type: "int",
            },
            chargeable_area_effective_rent: {
              name: "On Chargeable Area (Effective Rent)",
              type: "int",
            },
            carpet_area_current_rent: {
              name: "On Carpet Area (Current Rent)",
              type: "int",
            },
            chargeable_area_current_rent: {
              name: "On Chargeable Area (Current Rent)",
              type: "int",
            },
            key_occupiers: { name: "Key Occupiers", type: "string" },
            tenant: { name: "Occupier Name", type: "string" },
            building_name: { name: "Building Name", type: "string" },
            building_age: { name: "Building Age", type: "string" },
            starting_rent: {
              name: "Starting Rent (₹/Sqft/Month) On Chargeable Area",
              type: "int",
            },
            current_rent: {
              name: "Current Rent (₹/Sqft/Month) On Chargeable Area",
              type: "int",
            },
            commencement_date: { name: "Commencement Date", type: "string" },
            lease_expiry_date: { name: "Expiry Date", type: "string" },
            cre_id: { name: "CRE ID", type: "string" },
          }),
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      var body = new FormData();
      body.append("filter", JSON.stringify(this.props.filters));
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });
      apiMiddleware
        .post("api/edge/office/get_key_projects", body)
        .then((res) => {
          let splicedData = res.data;
          this.setState({ showLoader: false, showGraph: true });
          this.setState({
            keyProjects: splicedData,
            jsonForExcel: convertJsonForExcel(splicedData, {
              asset: { name: "Asset", type: "string" },
              micromarket: { name: "Micro-Market", type: "string" },
              asset_efficiency: { name: "Efficiency", type: "int" },
              leaseable_area: { name: "Leasable Area (msf)", type: "int" },
              occupancy_percent: { name: "Occupancy (%)", type: "int" },
              carpet_area_effective_rent: {
                name: "On Carpet Area (Effective Rent)",
                type: "int",
              },
              chargeable_area_effective_rent: {
                name: "On Chargeable Area (Effective Rent)",
                type: "int",
              },
              carpet_area_current_rent: {
                name: "On Carpet Area (Current Rent)",
                type: "int",
              },
              chargeable_area_current_rent: {
                name: "On Chargeable Area (Current Rent)",
                type: "int",
              },
              key_occupiers: { name: "Key Occupiers", type: "string" },
              occupier_name: { name: "Occupier Name", type: "string" },
              building_name: { name: "Building Name", type: "string" },
              building_age: { name: "Building Age", type: "string" },
              starting_rent: {
                name: "Starting Rent (₹/Sqft/Month) On Chargeable Area",
                type: "int",
              },
              current_rent: {
                name: "Current Rent (₹/Sqft/Month) On Chargeable Area",
                type: "int",
              },
              commencement_date: { name: "Commencement Date", type: "string" },
              lease_expiry_date: { name: "Expiry Date", type: "string" },
              cre_id: { name: "CRE ID", type: "string" },
            }),
          });
        });
    }
  }

  dateFilter = (dateValue) => {
    this.setState({
      start_date: dateValue.startDate,
      end_date: dateValue.endDate,
      which_date: dateValue.dateType,
      which_date_name: dateValue.dateTypeName,
      filters: "",
      isOpen: false,
    });
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => this.setState({ isOpen: false });

  getGradeWiseData() {
    if (this.state.grade == "All") {
      this.setState({ grade: "AA+" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("grade", this.state.grade);
        apiMiddleware
          .post("api/edge/office/get_key_projects", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            this.setState({
              keyProjects: res.data,
            });
          });
      });
    } else if (this.state.grade == "AA+") {
      this.setState({ grade: "All" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("grade", this.state.grade);
        apiMiddleware
          .post("api/edge/office/get_key_projects", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            this.setState({
              keyProjects: res.data,
            });
          });
      });
    }

    if (this.state.gradeText == "Switch To All Grade") {
      this.setState({ gradeText: "Switch To AA+" });
    } else if (this.state.gradeText == "Switch To AA+") {
      this.setState({ gradeText: "Switch To All Grade" });
    }
  }

  render() {
    return (
      <div className="widget widgetTable">
        {this.state.showLoader && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/edgeLoader.gif" />
            </div>
          </div>
        )}
        {this.state.showGraph && (
          <>
            <div className="row">
              <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                <p>Key Projects </p>
              </div>
              <div className="col-lg-3 text-end">
                <p className="colorBlack downloads">
                  <FontAwesomeIcon icon={faEllipsisV} />
                  <ul className="downloadOptions">
                    <li
                      className="excelDownload"
                      onClick={(e) => {
                        let body = new FormData();
                        body.append("path", window.location.pathname);
                        body.append("action", "excel_export");
                        body.append("count", 1);
                        body.append(
                          "hash",
                          window.location.search.split("?").pop()
                        );
                        body.append("screen_sub_type", "Key Projects");
                        apiMiddleware
                          .post(process.env.REACT_APP_USER_ACTIVITY, body)
                          .then((res) => {
                            console.log(res);
                          });
                      }}
                    >
                      <JsonToExcel
                        title="Download as Excel"
                        data={this.state.jsonForExcel}
                        fileName="KeyProjects"
                        btnClassName="download-table-xls-button"
                      />
                    </li>
                    {/* <li
                      className="pdfDownload"
                      onClick={(e) => {
                        downloadPdf("#keyProjects", "keyProjects");
                      }}
                    >
                      <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                    </li> */}
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.getGradeWiseData();
                      }}
                    >
                      {this.state.gradeText}
                    </li>
                  </ul>
                </p>
              </div>
              <div className="col-lg-12 mt-2 newFixedTable">
                <Table
                  className="keyProjects"
                  responsive
                  hover
                  id="keyProjects"
                >
                  <thead>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td colSpan={"2"} className="theadBorderBottom">
                        Effective Rent (₹/Sqft/month)
                      </td>
                      <td colSpan={"2"} className="theadBorderBottom">
                        Current Rent (₹/Sqft/month)
                      </td>
                      <td></td>
                      <td
                        colSpan={"7"}
                        className="theadBorderBottom keyProj text-center"
                      >
                        Latest Transactions
                      </td>
                      <td></td>
                      {/* <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td> */}
                    </tr>
                    {/* <tr className="">
                      <th>Asset</th>
                      <th>Micro-Market</th>
                      <th className="text-end">Efficiency</th>
                      <th className="text-end">Leasable Area (msf)</th>
                      <th className="text-end">Occupancy (%)</th>
                      <th className="text-end">On Carpet Area</th>
                      <th className="text-end">On Chargeable Area</th>
                      <th className="text-end">On Carpet Area</th>
                      <th className="text-end">On Chargeable Area</th>
                      <th>Key Occupiers</th>
                      <th>Occupier Name</th>
                      <th>Building Name</th>
                      <th>Building Age</th>
                      <th className="text-end">
                        Starting Rent (₹/Sqft/Month) On Chargeable Area
                      </th>
                      <th className="text-end">
                        Current Rent (₹/Sqft/Month) On Chargeable Area
                      </th>
                      <th>Commencement Date</th>
                      <th>Expiry Date</th>
                      <th className="text-end">CRE ID</th>
                    </tr> */}
                    <tr className="">
                      <th>
                        <span>Asset</span>
                      </th>
                      <th>
                        <span>Micro-Market</span>
                      </th>
                      <th className="text-end">
                        <span>Efficiency</span>
                      </th>
                      <th className="text-end">
                        <span>Leasable Area</span>
                      </th>
                      <th className="text-end">
                        <span>Occupancy</span>
                      </th>
                      <th className="text-end">
                        <span>On Carpet Area</span>
                      </th>
                      <th className="text-end">
                        <span>On Chargeable Area</span>
                      </th>
                      <th className="text-end">
                        <span>On Carpet Area</span>
                      </th>
                      <th className="text-end">
                        <span>On Chargeable Area</span>
                      </th>
                      <th>
                        <span>Key Occupiers</span>
                      </th>
                      <th>
                        <span>Occupier Name</span>
                      </th>
                      <th>
                        <span>Building Name</span>
                      </th>
                      <th>
                        <span>Building Age</span>
                      </th>
                      <th className="text-end">
                        <span>Starting Rent On Chargeable Area</span>
                      </th>
                      <th>
                        <span>Commencement Date</span>
                      </th>
                      <th>
                        <span>Expiry Date</span>
                      </th>
                      <th className="text-end">
                        <span>CRE ID</span>
                      </th>
                    </tr>
                    <tr className="thwithNoPadding">
                      <th></th>
                      <th></th>
                      <th className="text-end">
                        <b>(%)</b>
                      </th>
                      <th className="text-end">
                        <b>(msf)</b>
                      </th>
                      <th className="text-end">
                        <b>(%)</b>
                      </th>
                      <th className="text-end"></th>
                      <th className="text-end"></th>
                      <th className="text-end"></th>
                      <th className="text-end"></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th className="text-end">
                        <b>(₹/Sqft/Month)</b>
                      </th>
                      <th></th>
                      <th></th>
                      <th className="text-end"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.keyProjects.map((row, i) => (
                      <tr className="" key={i}>
                        <td>
                          <Link
                            target="_blank"
                            to={encodedUrlBuliding("complex", row.asset)}
                          >
                            {row.asset}
                          </Link>
                        </td>
                        <td>{row.micromarket}</td>
                        <td className="text-end">{row.asset_efficiency}</td>
                        <td className="text-end">
                          {row.leaseable_area.toLocaleString()}
                        </td>
                        <td className="text-end">{row.occupancy_percent}</td>
                        <td className="text-end">
                          {row.carpet_area_effective_rent}
                        </td>
                        <td className="text-end">
                          {row.chargeable_area_effective_rent}
                        </td>
                        <td className="text-end">
                          {row.carpet_area_current_rent}
                        </td>
                        <td className="text-end">
                          {row.chargeable_area_current_rent}
                        </td>
                        <td>{row.key_occupiers}</td>
                        <td>
                          <Link
                            target="_blank"
                            to={encodedUrlBuliding("tenant", row.occupier_name)}
                          >
                            {row.occupier_name}
                          </Link>
                        </td>
                        <td>{row.building_name}</td>
                        <td>{row.building_age}</td>
                        <td className="text-end">{row.starting_rent}</td>
                        {/* <td className="text-end">{row.current_rent}</td> */}
                        <td>{row.commencement_date}</td>
                        <td>{row.lease_expiry_date}</td>
                        <td className="text-end">
                          <Link
                            target="_blank"
                            to={encodedUrlBuliding("leaseId", row.cre_id)}
                          >
                            {row.cre_id}
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(KeyProjects);
